import { parseMDX } from "@/lib/mdx"
import LegalScene from "@/scenes/LegalScene"
import markdown from "~/i18n/es/cookies.md"

export default function Cookies({ content }) {
  return <LegalScene title="Mi Coche De Renting - Uso de cookies" pageName="cookies" markdown={content} />
}

export async function getStaticProps() {
  const parsedMdx = await parseMDX(markdown)
  return { props: { content: parsedMdx } }
}
